export { default as LoginFooterComponent } from "./LoginFooterComponent";
